import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
function Index() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [noOfClient, setNoOfClient] = useState('0');
  const [noOfStake, setNoOfStake] = useState('0');
  const [noOfWithdraw, setNoOfWithdraw] = useState('0');
  const [totalActive, setTotalActive] = useState('0');
  const [recentClient, setRecentClient] = useState([]);
  const [recentStake, setRecentStake] = useState([]);
  const [recentWithdraw, setResentWithdraw] = useState([]);
  const [recentalyDeposit, setRecentalyDeposit] = useState([]);
  const [tabelLoading, setTableLoading] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      //console.log('Token ', authToken);
      try {
        const statics = await fetch(`${baseurl}/statics`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (statics.status === 429) {
          //  console.error("Rate limit exceeded. Please try again later.");
          return; // Stop further processing
        }

        const staticResult = await statics.json();
        console.log('Static data', staticResult);

        if (staticResult.status) {
          setNoOfClient(staticResult.total_clients);
          setNoOfStake(staticResult.no_of_stake);
          setNoOfWithdraw(staticResult.no_of_withdraw);
          setTotalActive(staticResult.no_of_active);
          setRecentClient(staticResult.recent_clients);
          setRecentStake(staticResult.recent_stake);
          setResentWithdraw(staticResult.recent_withdraw);

          setTableLoading(true);
        } else {
          // Handle any error condition
          setTableLoading(true);
        }

      } catch (error) {
        //  console.error('Fetch error:', error);
        setTableLoading(true);
      }
    };

    fetchProfileData();
  }, []);


  return (
    <>
      <Header>
        <Auth />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Hi, welcome back!</h4>

              </div>
            </div>
            {/* End Page Header */}
            {/* row */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {noOfClient || '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL TRADE</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {noOfStake || '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">ACTIVE USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {Number(totalActive || 0)}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL WITHDRAW</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {noOfWithdraw || '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>
            </div>
            {/* row closed */}
            {/* row opened */}

            {/* row closed */}
            {/* row opened */}
            <div className="row">
              <div className="col-xl-6 col-md-12 col-lg-12">
                <div className="card overflow-hidden">
                  <div className="card-header pb-1">
                    <h3 className="card-title mb-2">Recent Clients</h3>

                  </div>
                  <div className="card-body p-0 customers mt-1">
                    {tabelLoading ? (

                      <div className="list-group list-lg-group list-group-flush">
                        {recentClient.length > 0 ? (
                          recentClient.map((client, index) => (
                            <div key={index} className="list-group-item list-group-item-action">
                              <div className="d-flex">
                                <img
                                  className="avatar avatar-md rounded-circle my-auto me-3"
                                  src={client.profile_image || 'assets/images/profile/profile1.avif'} // You can replace this with a dynamic image URL if available
                                  alt="Image description"
                                />
                                <div className="flex-grow-1">
                                  <div className="d-flex align-items-center">
                                    <div className="mt-0">
                                      <h5 className="mb-1 fs-15">{client.name}</h5> {/* Rendering client's name dynamically */}
                                      <p className="mb-0 fs-13 text-muted">
                                        {client ? client.created_at.slice(0, 18) : '0'}  {/* Rendering user's ID dynamically */}
                                      </p>
                                    </div>
                                    <div className="ms-auto w-45 fs-16 mt-2">
                                      <div id="spark1" className="w-100" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>No recent clients found.</p>
                        )}
                      </div>

                    ) : (
                      <div className="text-center">
                        <div class="d-flex justify-content-center mb-4">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                </div>
              </div>
              <div className="col-xl-6 col-md-12 col-lg-6">
                <div className="card">
                  <div className="card-header pb-1">
                    <h3 className="card-title mb-2">Recentaly Trades</h3>

                  </div>
                  {tabelLoading ? (
                    <div className="product-timeline card-body pt-2 mt-1">
                      <ul className="timeline-1 mb-0">


                        {recentStake.length > 0 ? (
                          recentStake.map((accessKeys, index) => (
                            <li className="mt-0">

                              <img className="bg-primary-gradient text-fixed-white product-icon" src="assets/images/logo/accessKeys.png" width={60} />{" "}
                              <span className="fw-medium mb-4 fs-14">{accessKeys && accessKeys.stake_amount} {accessKeys && accessKeys.stake_asset}
                              </span>{" "}
                              <a href="javascript:void(0);" className="float-end fs-11 text-muted">
                                <h4 className={`badge ${accessKeys.stake_status === 'active' ? 'bg-success' : 'bg-danger'}`}> {accessKeys.status}</h4>

                              </a>
                              <p className="mb-0 text-muted fs-12">{accessKeys.date_time || 'N/A'}</p>
                            </li>
                          ))
                        ) : (
                          <p>No recent clients found.</p>
                        )}
                      </ul>
                    </div>
                  ) : (
                    <div className="text-center">
                      <div class="d-flex justify-content-center mb-4">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* row close */}
            {/* row opened */}
            <div className="row">

              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between">
                    <h4 className="card-title mb-1">Recentaly Withdraw</h4>

                  </div>
                  <div className="table-responsive country-table">
                    {tabelLoading ? (
                      <table className="table table-striped table-bordered mb-0 text-nowrap">
                        <thead>
                          <tr>
                            <th className="wd-lg-25p">Amount</th>
                            <th className="wd-lg-25p">Address</th>
                            <th className="wd-lg-25p">Date Time</th>
                            <th className="wd-lg-25p">STATUS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {recentWithdraw.length > 0 ? (
                            recentWithdraw.map((withdraws, index) => (
                              <tr>
                                <td>{withdraws.withdraw_amount || '0'} </td>
                                <td className="fw-medium">{withdraws.to_address || 'N/A'}</td>
                                <td className="fw-medium">{withdraws.date_time || 'N/A'}</td>
                                <td className="text-danger fw-medium">{withdraws.status || 'N/A'}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>No Data Found</td>
                            </tr>
                          )}


                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center">
                        <div class="d-flex justify-content-center mb-4">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* /row */}
          </div>
        </div>
      </Header>

      <Footer />

    </>
  )
}

export default Index